export default __webpack_public_path__ + "static/404-a4b5d95c620892be6ef6e3ab3f4542b3.svg";